<paging [len]="len" [page]="page" [config]="config" [totalItems]="total" (changePage)="handleOnChangePage($event);"
  (totalPage)="handleOnTotalPage($event)" (changeLen)="onChangeLen($event)" [turnOnTotalPage]="true"
  [turnOnPagination]="false" [turnOnTotalItem]="true" [isMobile]="true" [pdtLen]="true"></paging>
<div class="mainProd prodList">
   <ul class="" *ngIf="products.length > 0">
    <ng-container *ngFor="let product of true ? (products | paginate : config) : products">
      <li [product]="product"></li>
    </ng-container>
  </ul>
  <ng-container *ngIf="products.length == 0">
    <div class="container d-flex justify-content-center align-items-center vh-50">
      <div class="alert text-center custom-alert" role="alert">
         {{'no-data' | translate}}
      </div>
    </div>
  </ng-container>
</div>
<!-- <products [products]="products" [config]="config" [urlWownet]="urlWownet" (itemProduct)="getItemOfProduct($event);">
</products> -->

<paging [len]="len" [page]="page" [config]="config" [totalItems]="total" (changePage)="handleOnChangePage($event);"
  (totalPage)="handleOnTotalPage($event)" (changeLen)="onChangeLen($event)" [turnOnTotalPage]="true"
  [turnOnPagination]="true" [turnOnTotalItem]="true" [isMobile]="false" [pdtLen]="true"></paging>
